import { action, makeObservable, observable } from "mobx";
import { gameRulesKeysByGameId, licenseRulesKeysByGameId, oddsInfoEnumsByGame, payTableOddsByGameId, payTableStepsContentByGame } from "../../constants/payTableConstants";
import { isMobile } from "../../helpers/isMobile";
import { gameResources } from "../../constants/gameResources";
import { soundResources } from "../../constants/soundResources"
import { appDefaultValuesEnum } from "../../constants/appDefaultValues";
import { gameNameById, winPopupConfigs } from '../../constants/enumsByGames';
import { reelParamsByGame, reelsContainerParamsByGame, symbolSizesByGame } from "../../constants/reelConstants";
import { initialGameResources } from "../../constants/initialResources";


class GameConfigurationStore {
    gameConfigurationisReady = false;
    gameConfiguration = {};
    isReplay = false;
    gameId = null;
    reelsParams = null;
    symbolsSizes = null;
    reelsContainerParams = null;
    constructor() {
        makeObservable(this, {
            gameId: observable,
            isReplay: observable,
            reelsParams: observable,
            symbolsSizes: observable,
            reelsContainerParams: observable,
            gameConfigurationisReady: observable,
            setGameConfigurationisReady: action.bound,
            createGameConfigurationTree: action.bound,
            createReelsParams: action.bound,
            setSymbolsSizes: action.bound,
            setReelsContainerParams: action.bound
        })
    }
    createGameConfigurationTree = ({ gameid, replaymode }) => {
        if (!gameid) return
        this.gameId = gameid;
        this.isReplay = replaymode;
        this.createGameConfigs();
        this.setSymbolsSizes();
        this.setReelsContainerParams()
        this.createReelsParams();
        this.setGameConfigurationisReady(true)
    }

    createGameConfigs = () => {
        this.gameConfiguration = {
            oddsInfoEnum: oddsInfoEnumsByGame[this.gameId][isMobile() ? 'oddsInfoEnumMobile' : 'oddsInfoEnumWeb'],
            payTableStepsContent: payTableStepsContentByGame[this.gameId],
            payTableOdds: payTableOddsByGameId[this.gameId],
            gameRulesKeys: gameRulesKeysByGameId,
            licenseRulesKeys: licenseRulesKeysByGameId,
            bgConfigs: { x: 0, y: 0 },
            logoConfigs: {
                x: isMobile() ? 268 : 720,
                y: isMobile() ? 175 : 60,
            },
            soundResources,
            initialGameResources: initialGameResources(gameNameById[this.gameId]),
            gameResources: gameResources(gameNameById[this.gameId]),
            loadingSpinePosition: {
                x: isMobile() ? window.innerWidth / 2 : 720,
                y: isMobile() ? window.innerHeight / 2 : 405,

            },
            gameName: gameNameById[this.gameId],
            AppDefaultValuesEnum: appDefaultValuesEnum(this.gameId),
            reelsCount: reelParamsByGame[this.gameId].reelsCount,
            isReplay: this.isReplay,
            winPopupConfigs,
        }
    }

    createReelsParams = () => {
        this.reelsParams = Array(reelParamsByGame[this.gameId]['reelsCount']).fill(reelParamsByGame[this.gameId]['reelParams'])
    }

    setSymbolsSizes = () => {
        this.symbolsSizes = symbolSizesByGame[this.gameId];
    }

    setReelsContainerParams = () => {
        this.reelsContainerParams = reelsContainerParamsByGame[this.gameId]
    }

    setGameConfigurationisReady = (status) => {
        this.gameConfigurationisReady = status
    }

}

export const gameConfigurationStore = new GameConfigurationStore()